






















import {
  defineComponent,
  onMounted,
  SetupContext,
  reactive,
} from '@vue/composition-api'
import { getCuurentOfficeData } from '@/lib/define/use-office-data'
import { handleGetCheckOfficeNumber } from '@/lib/achievements/utils'

type StateType = {
  isShow: boolean
  mainText: string
  subText: string
}

export default defineComponent({
  props: {
    btnLabel: {
      type: String,
      required: true,
    },
    subject: {
      type: String,
      required: true,
    },
    mailToAddress: {
      type: String,
      required: true,
    },
    bodyFirstWord: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props, context: SetupContext) {
    const state: StateType = reactive({
      isShow: false,
      mainText: 'データを取得中です。',
      subText: '少々お待ちください。',
    })

    onMounted(() => {
      state.isShow = true
    })

    const handleEmailLink = async () => {
      state.isShow = false

      // 事業所データ取得
      const officeDataArray = await getCuurentOfficeData()

      const officeNumber = handleGetCheckOfficeNumber(
        officeDataArray.unit_flg,
        String(officeDataArray.office_number)
      )

      state.isShow = true

      context.root.$nextTick(() => {
        const subject = props.subject
        const officeName = officeDataArray.office_name
        const staffName = officeDataArray.admin
        const contactMailAddress = officeDataArray.mail_address
        const phoneNumber = officeDataArray.phone_number
        const zip = officeDataArray.zip
        const address = `${officeDataArray.prefecture}${officeDataArray.city}${officeDataArray.block}${officeDataArray.building}`

        const body = `${props.bodyFirstWord}%0d%0a%0d%0a事業所番号：${officeNumber}%0d%0a事業所名：${officeName}%0d%0aご担当者様のお名前：${staffName}%0d%0aご連絡先メールアドレス：${contactMailAddress}%0d%0a電話番号：${phoneNumber}%0d%0a郵便番号：${zip}%0d%0aご郵送先住所：${address}`
        
        location.href = `mailto:${props.mailToAddress}?subject=${subject}&body=${body}`
      })
    }

    return {
      props,
      handleEmailLink,
      state,
    }
  },
})
